<template>
  <h2>{{ props.title }}</h2>
  <div class="subtitle">
    <div class="subtitle-text">
      {{ `${props.formation_title}` }}
    </div>
    <template v-if="props.session_date">
      <IconSeparatorVertical />
      <div class="subtitle-icon-date">
        <IconDate />
      </div>
      <div class="subtitle-text">
        {{ props.session_date }}
      </div>
    </template>
    <template v-if="props.participant_nom_prenom">
      <IconSeparatorVertical />
      <div class="subtitle-icon-date">
        <IconMyAccount />
      </div>
      <div class="subtitle-text">
        {{ props.participant_nom_prenom }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import IconDate from '@/assets/img/refonte/icons/information/icon-date.svg?component';
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import IconSeparatorVertical from '@/assets/img/refonte/icons/display/icon-separator-vertical.svg?component';

  const props = withDefaults(
    defineProps<{
      title?: string;
      formation_title?: string;
      session_date?: string;
      participant_nom_prenom?: string;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped>
  .subtitle {
    @apply flex grow flex-wrap items-center self-stretch;
    gap: 8px;

    .subtitle-text {
      font-size: 13px;
      font-weight: 400;
      line-height: 16px;
    }

    .subtitle-icon-date {
      @apply flex items-center justify-center;
      height: 16px;

      :deep(svg) {
        @apply text-refonte_blue-200;
        width: 16px;
        height: 16px;
      }
    }
  }
</style>
